import Helper from '@/resources/Helper';
import SyncEngine from '@/database/_Sync';

const _DBName = 'posyellowtiredb';
const _DBVersion = 1;
const _BrowserNotSupport = 'โปรดเปลี่ยน Browser สำหรับใช้งานระบบ';

let dbConn;

const functions = {
	syncAction() {
		return {
			add: 'add',
			update: 'update',
			delete: 'delete',
			newdot: 'newdot',
			deleteDot: 'deleteDot',
			adjuststock: 'adjustStock',
			reserveStock: 'reserveStock',
			deductStock: 'deductStock',
			returnReserve: 'returnReserve'
		};
	},
    async getDb() {
		return new Promise((resolve, reject) => {
			if (dbConn) {
                return resolve(dbConn);
            }

			let request = window.indexedDB.open(_DBName, _DBVersion);
			
			request.onerror = () => {
				alert(_BrowserNotSupport);
				reject('Error');
			};
	
			request.onsuccess = e => {
				dbConn = e.target.result;
				resolve(dbConn);
			};
			
			request.onupgradeneeded = e => {
				let db = e.target.result;

				db.createObjectStore('store');
				db.createObjectStore('car');
				db.createObjectStore('carTireSize');
				db.createObjectStore('tireSize');
				db.createObjectStore('fleet');
				db.createObjectStore('prospect');
				db.createObjectStore('inventory');
				db.createObjectStore('stock');
				db.createObjectStore('stockHistory');
				db.createObjectStore('storeService');
				db.createObjectStore('customer');
				db.createObjectStore('customerStore');
				db.createObjectStore('accounting');
				db.createObjectStore('job');
				db.createObjectStore('inspection');
				db.createObjectStore('booking');
				db.createObjectStore('supplier');
				db.createObjectStore('masterProduct');
				db.createObjectStore('syncPipeline');
			};
		});
	},
	async getContentObject(tableName) {
        // Load Data
        const entity = await this.getRecord(tableName);

        // Return Model
        const result = this.initReturnResult();

        if (entity.value) {
            result.version = entity.key;
            result.content = entity.value;
        }

        return result;
	},
	async getContentList(tableName) {
        // Load Data
        const entity = await this.getRecord(tableName);
        
        // Return Model
        const list = [];
        const result = this.initReturnResult();

        if (entity.value) {
            entity.value.forEach((item) => {
                list.push(item);
            });

            result.version = entity.key;
            result.content = list;
        } else {
            result.content = [];
        }
        
        return result;
    },
	async getContentDetailByKey(list, key) {
		if (list.content && list.content.length > 0) {
            return list.content.find(x => x.key === key);
        }

        return null;
	},
	async getRecord(tableName) {
        const db = await this.getDb();
        
        return new Promise(resolve => {
            const trans = db.transaction([tableName], 'readonly');
            const store = trans.objectStore(tableName);
            
            trans.oncomplete = () => {
				resolve(result);
			};

            let result = {};

            store.openCursor().onsuccess = (e) => {
				const cursor = e.target.result;

                if (cursor) {
                    result = cursor;
                }
			};
		});
    },
	async replaceRecord(tableName, value, key) {
		await this.clearTable(tableName);

        const db = await this.getDb();

		return new Promise(resolve => {
			const trans = db.transaction([tableName], 'readwrite');
            const store = trans.objectStore(tableName);
            
			trans.oncomplete = () => {
				resolve();
			};

			store.put(value, key);
		});
    },
	async clearTable(tableName) {
        const db = await this.getDb();

		return new Promise(resolve => {
			const trans = db.transaction([tableName], 'readwrite');
            const store = trans.objectStore(tableName);
            
			trans.oncomplete = () => {
				resolve();
			};

			store.clear();
		});
    },
	initReturnResult() {
		return { version: 0, content: null };
	},
	async updateListData(tableName, currentData, value, operation) {
		// Stamp Update Time
		value['timestamp'] = Helper.getClientTime();

		// Manage Data List
		switch (operation) {
			case this.syncAction().add: {
				value['key'] = Helper.generateGUID();
				currentData.content.push(value);

				break;
			}
			case this.syncAction().update: {
				for (let index = 0; index < currentData.content.length; index++) {
					if (currentData.content[index].key === value.key) {
						currentData.content[index] = value;
						break;
					}
				}

				break;
			}
			case this.syncAction().delete: {
				const index = currentData.content.findIndex(x => x.key === value.key);
				currentData.content.splice(index, 1);

				break;
			}
		}

		// Setup Current IndexedDB
		await this.replaceRecord(tableName, currentData.content, currentData.version);

		// Sync Pipeline
		SyncEngine.setupSyncPipeline(tableName, operation, value);

		return value;
	}
}

export default functions;